import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=5b97f2bc&scoped=true&"
import script from "./ArticleItem.vue?vue&type=script&lang=js&"
export * from "./ArticleItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticleItem.vue?vue&type=style&index=0&id=5b97f2bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b97f2bc",
  null
  
)

export default component.exports